const SectionHowTo = Class(
	/**
	 * @lends {SectionHowTo#}
	 */
	{
		bodyClass: 'small-nav',
		menuItem: 'how',

		draw: function() {
			this.node = mkE({
				tag: 'div',
				id: 'SectionHowTo',
				els: [
					{
						tag: 'div',
						id: 'hero',
						className: 'container',
						els: [
							{
								tag: 'div',
								els: [
									{
										tag: 'h1',
										innerHTML: t('how-to.welcome.title')
									},
									{
										tag: 'div',
										className: 'hero__p',
										text: t('how-to.welcome.text')
									}
								]
							},
							{
								tag: 'div',
								els: [
									{
										tag: 'a',
										href: D.url(D.Lang.get('how-to.welcome.button.link')),
										className: 'button button-large button-pink',
										text: D.Lang.get('how-to.welcome.button')
									}
								]
							}
						]
					},
					{
						tag: 'div',
						className: 'mb-5 howto__game_flow',
						els: [
							new T.GameFlow()
						]
					},
					{
						tag: 'div',
						className: 'mb-5',
						els: [
							new T.EasyAccess()
						]
					},
					{
						tag: 'div',
						className: 'mb-5',
						els: [
							this._howTo = new T.HowTo([
								'matchmaker',
								'g-spot',
								'explorer',
								'sprinter',
								'hunter',
								'groupie',
								'expert',
								'detective',
								'coder',
								'golddigger'
							], 'matchmaker')
						]
					},
					new T.FooterRegister()
				]
			}).append(this.layout.ct());

			this.ready();
		},

		onShow() {
			if (this._howTo) {
				this._howTo.onShow();
			}
		},

		onLeave() {
			if (this._howTo) {
				this._howTo.onLeave();
			}
		}
	},
	Section
);